<template>
  <v-text-field
    :key="props.id"
    :id="props.field"
    :error="error"
    :data-cy="props.id.split('_')[1] + '-' + props.field"
    v-bind="$attrs"
    ref="inputField"
    v-model="value"
    :hide-spin-buttons="true"
    :label="hideLabel ? '' : label || t(`entities.${type}.fields.${field}`)"
    :readonly="readonly"
    :class="{ occupied: isOccupied, readonly: readonly }"
    role="CalcInput"
    @keypress="isNumber"
    @update:focused="watchFocus"
    @wheel="() => inputField?.blur()">
    <!--TODO readonly not clickable-->
    <template
      v-if="props.icon"
      #prepend>
      <icon-loader :name="props.icon" />
    </template>
    <v-avatar
      size="20"
      v-if="isOccupied"
      color="primary"
      style="position: fixed; right: 10px; top: 10px; font-size: 12px">
      {{ mainStore.getInitials(isOccupied) }}
    </v-avatar>
    <template #append  v-if="authStore.isSuperUser">
      <math-tooltip :name="props.field" :title="label || t(`entities.${type}.fields.${field}`)"/>
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { ref, toRef } from "vue";
import IconLoader from "@/components/tools/IconLoader.vue";
import { useMainStore } from "@/stores/mainStore";
import { useCalcInput } from "./calcInputComposable";
import EditTooltip from "../dialogs/EditTooltip.vue";
import MathTooltip from "./MathTooltip.vue";
import { useAuthStore } from "@/stores/authStore";

const copyName = () => {
  navigator.clipboard.writeText(`,"${props.field}"`);
};

const authStore = useAuthStore();
const mainStore = useMainStore();

const { t } = useTranslation();

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  hideLabel: {
    type: Boolean,
    default: false
  },
  component: {
    type: String,
    default: "v-text-field"
  },
  readonly: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: null
  },
  noCalculation: {
    type: Boolean,
    default: false
  },
  modelArgument: {
    type: String,
    default: "modelValue"
  },
  items: {
    type: Array,
    default: []
  }
});

const [_, type] = props.id.split("_");

const { inputField, isOccupied, error, watchFocus, value, isNumber, readonly } =
  useCalcInput(
    toRef(() => props.id),
    toRef(() => props.field),
    props.readonly,
    "number"
  );
</script>
<style scoped lang="scss">
.calc-input {
  /* Add your styles here */
  /* border: 1px solid #ccc;
  padding: 3px 5px 3px 8px;
  border-radius: 4px;
  width: 100%; */
}

.error {
  border-color: red;
}

.occupied {
  /* background-color: #f0f0f0; */
  opacity: 0.3;
  pointer-events: none;
}

.readonly {
  /* background-color: #f0f0f0; */
  opacity: 0.8;
  pointer-events: none;
}
</style>
